import React, { useEffect, useId, useRef, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { showVideoModalActive } from "../../redux/slices/activityCategories";

import DOMPurify from "dompurify";

// will display elements of a single activity category ie. category name and icon
//clicking on any category will select that category

export default function ActivityCategory({ index, id, icon, name, isSelected, setBottomSliderX, swiperChanged, setBottomSliderIndex }) {
  const categoryRef = useRef(null);
  const { width } = useWindowDimensions();

  const divId = (index + icon).toString();

  //set index of selected category
  useEffect(() => {
    if (isSelected) {
      setBottomSliderIndex(index);
    }
  }, [isSelected, width]);

  //change bottom bar position
  useEffect(() => {
    if (isSelected) {
      setBottomSliderX(categoryRef.current.parentElement.getBoundingClientRect().x);
    }
  }, [isSelected, width]);

  //when slider changes after scrolling horizontally
  useEffect(() => {
    let t;
    if (isSelected) {
      if (swiperChanged !== 0) {
        t = setTimeout(() => {
          setBottomSliderX(categoryRef.current.parentElement.getBoundingClientRect().x);
        });
      }
    }
    return () => clearTimeout(t);
  }, [swiperChanged, width]);

  const [svg, setSvg] = useState("");
  useEffect(() => {
    let url;
    if (icon.toString().includes("https")) {
      url = icon;
    } else {
      // url = icon.toString().replace("http", "http");
      url = icon
    }

    fetch(url)
      .then((r) => r.text())
      .then((text) => {
        setSvg(DOMPurify.sanitize(text));
      })
      .catch(console.error.bind(console));
  }, []);

  return (
    <div ref={categoryRef} className="d-flex flex-column align-items-center swiper_slide__activity_category">
      <div className={`d-flex icon__container category-icon ${isSelected ? "icon-active" : ""} `} dangerouslySetInnerHTML={{ __html: svg }}></div>
      <p className={"category_name"}> {name} </p>
      {/* <div className={`d-flex icon__container category-icon ${isSelected ? "icon-active" : ""} `} dangerouslySetInnerHTML={{ __html: svg }}></div>
      <p className={isSelected ? "category_name active" : "category_name"}> {name} </p> */}
    </div>
  );
}
// ${isSelected ? "icon-active" : ""}
// isSelected ? "category_name active" : 